import { HTTP } from '@community_dev/requests'
import { Api } from '@community_dev/types'
import { CamelCasedPropertiesDeep } from 'type-fest'

import { ENDPOINTS } from 'constants/endpoints'
import { request } from 'utils/request'
import { route } from 'utils/router'

export type RegistrationV2 = CamelCasedPropertiesDeep<Api.V2.TCR.Registration>

export type CommunityBrand = CamelCasedPropertiesDeep<Api.V2.TCR.CommunityBrand>
export type CommunityCampaign = CamelCasedPropertiesDeep<Api.V2.TCR.CommunityCampaign>
export type CommunityRegistration = CamelCasedPropertiesDeep<Api.V2.TCR.CommunityRegistration>
export type CommunityRegistrationResponse = CamelCasedPropertiesDeep<Api.V2.TCR.CommunityRegistrationResponse>

export function getTRCRegistration({
  clientId,
  seatId,
}: {
  clientId: string
  seatId: string
}): Promise<RegistrationV2> {
  return request(route(ENDPOINTS.TCR.REGISTRATION, { clientId, seatId }))
}

export function resetTCRStatus({ clientId }: { clientId: string }): Promise<''> {
  return request(route(ENDPOINTS.TCR.REGISTRATION_SUBMISSION, { clientId }), {
    method: 'DELETE',
  })
}

export function getCommunityRegistrations(clientId: string): Promise<CommunityRegistrationResponse> {
  return request(route(ENDPOINTS.TCR.COMMUNITY_REGISTRATIONS, { clientId }))
}

export function patchCommunityRegistration({
  clientId,
  isExempt,
}: {
  clientId: string
  isExempt: boolean
}): Promise<CommunityRegistrationResponse> {
  return request(route(ENDPOINTS.TCR.COMMUNITY_REGISTRATIONS, { clientId }), {
    method: HTTP.PATCH,
    body: { isExempt },
  })
}

export function linkTCRBrand({
  clientId,
  externalBrandId,
}: {
  clientId: string
  externalBrandId: string
}): Promise<{ data: CommunityBrand }> {
  return request(route(ENDPOINTS.TCR.LINK_BRAND, { clientId, externalBrandId }), {
    method: HTTP.POST,
  })
}

export function linkTCRCampaign({
  clientId,
  externalCampaignId,
}: {
  clientId: string
  externalCampaignId: string
}): Promise<{ data: CommunityCampaign }> {
  return request(route(ENDPOINTS.TCR.LINK_CAMPAIGN, { clientId, externalCampaignId }), {
    method: HTTP.POST,
  })
}
